import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { filter } from "rxjs";
import { AdminService } from "../admin.service";
import { T } from "@angular/cdk/keycodes";

@Component({
  selector: "app-admin-tax-edit",
  templateUrl: "./admin-tax-edit.component.html",
  styleUrls: ["./admin-tax-edit.component.css"],
})
export class AdminTaxEditComponent implements OnInit {
  truckCategory: any = [];
  truckTypeList: any = [];
  trucksTypeList: any = [];
  taxArray: any = [];
  s9Array: any = [];
  customerArray: any = [];
  driverArray: any = [];
  exemptedArray: any = [];
  editTax: boolean = false;
  TaxForm: FormGroup;
  editButton: boolean = true;
  token: any;
  category: any = [];
  truckType: any = [];
  loading: boolean = false;
  selectTaxValue: any;
  edit_Tax: any;
  perPage: any = 100;
  startPage: any = 1;
  searchEmployeeName: any = -1;
  
  constructor(
    private matdialogref: MatDialogRef<AdminTaxEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private services: AdminService,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.taxFormGroup();
    this.GetCategory();
    this.getTruckType();
    this.TaxForm.patchValue(this.data);
  }
  closeTax() {
    this.matdialogref.close();
  }

  public GetCategory() {
    this.services
      .GetCategory(
        this.token,
        this.searchEmployeeName,
        this.perPage,
        this.startPage
      )
      .subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.truckCategory = response.body.data;
            this.category = this.truckCategory.filter((ele: any) => {
              return ele._id == this.data.truck_category;
            });
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
  public getTruckType() {
    this.services.GetTrucksType(this.token).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.truckTypeList = response.body.data;
          this.truckType = this.truckTypeList.filter((ele: any) => {
            return ele._id == this.data.truck_type;
          });
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
  getTaxtype(item: any) {
    this.edit_Tax = item.value;
  }
  gettruckCatg(item: any) {
    this.selectTaxValue = item.value;
    this.services.GetTypeTruck(this.selectTaxValue, this.token).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.truckTypeList = response.body.data;
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  taxFormGroup() {
    this.TaxForm = this.formBuilder.group({
      tax_name: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern(/[a-zA-Z0-9\s]*$/),
        ]),
      ],
      // tax_deduction: [
      //   "",
      //   Validators.compose([
      //     Validators.required,
      //     Validators.pattern("^[.0-9]*$"),
      //   ]),
      // ],
      tax_description: ["", [Validators.required]],
      // tax_type: ["", [Validators.required]],
    });
    if (this.data?.tax_user_type !== "customerGST") {
      this.TaxForm.addControl(
        "tax_deduction",
        this.formBuilder.control("", [
          Validators.required,
          Validators.pattern("^[.0-9]*$"),
        ])
      );
      this.TaxForm.addControl(
        "tax_type",
        this.formBuilder.control("", Validators.required)
      )
    }
    if (this.data?.tax_user_type === "customerGST") {
      this.TaxForm.addControl(
        "hsn_code",
        this.formBuilder.control("", Validators.required)
      );
      this.TaxForm.addControl(
        "rcm_deduction",
        this.formBuilder.control("")
      );
      this.TaxForm.addControl(
        "fcm_deduction",
        this.formBuilder.control("")
      );
    }
  }
  public get taxEditFormControl() {
    return this.TaxForm.controls;
  }
  edit() {
    this.editButton = false;
    this.editTax = true;
    this.taxEditFormControl["truck_category"].setValue(
      this.data.truck_category
    );
    this.taxEditFormControl["truck_type"].setValue(this.data.truck_type);
    this.taxEditFormControl["tax_name"].setValue(this.data.tax_name);
    this.taxEditFormControl["tax_deduction"].setValue(this.data.tax_deduction);
    this.taxEditFormControl["tax_description"].setValue(
      this.data.tax_description
    );
    this.taxEditFormControl["tax_type"].setValue(this.data.tax_type);
  }
  getTax() {}
  updateTax() {
    if (this.TaxForm.valid) {
      let updateObj: any = {
        tax_name: this.TaxForm.value.tax_name.toUpperCase(),
        tax_description: this.TaxForm.value.tax_description,
        tax_user_type: this.data.tax_user_type,
      };

      // Non-customerGST taxes
      if (this.data.tax_user_type !== "customerGST") {
        updateObj.truck_category = this.TaxForm.value.truck_category;
        updateObj.truck_type = this.TaxForm.value.truck_type;
        updateObj.tax_deduction = this.TaxForm.value.tax_deduction;
        updateObj.tax_type = this.TaxForm.value.tax_type;
      }

      // Customer GST-specific fields
      if (this.data.tax_user_type === "customerGST") {
        updateObj.hsn_code = this.TaxForm.value.hsn_code;
        updateObj.rcm_deduction = this.TaxForm.value.rcm_deduction || 0;
        updateObj.fcm_deduction = this.TaxForm.value.fcm_deduction || 0;
        updateObj.tax_type = "percent";
      }

      this.loading = true;
      this.services.taxUpdate(updateObj, this.token, this.data._id).subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.snackBar.open("Tax Updated successfully", "Success", {
              duration: 3000,
            });
            this.matdialogref.close(updateObj);
            this.loading = false;
          }
        },
        (error) => {
          if (
            error.error.message === "jwt malformed" ||
            error.error.message === "jwt expired" ||
            error.error.message === "invalid signature"
          ) {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", { duration: 5000 });
          this.loading = false;
        }
      );
    } else {
      this.TaxForm.markAllAsTouched();
    }
  }
}
